module.exports = __webpack_public_path__ + "static/media/commi.6d0c52d6.png";